import React from 'react'

import {
  List,
  Datagrid,
  ChipField,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  EditButton,
  ShowButton,
  Edit,
  SimpleForm,
  DisabledInput,
  TextInput,
  Create,
  DateInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  Delete,
  SimpleShowLayout,
  LongTextInput,
} from 'admin-on-rest'

import {
  referenceKeyParser,
  referenceKeyFormatter,
  dateFormatter,
  dateParser,
} from '../helpers'

import DateTimeInput from '../components/DateTimeInput'

const CourseTitle = ({ record }) => {
  return <span>{record ? `${record.name}` : ''}</span>
}

export const AdminCourseRemove = props => (
  <Delete title={<CourseTitle />} {...props} />
)



// WEBPACK FOOTER //
// ./src/admin/AdminCourseRemove.js